import type { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

/**
 * Permissions for the external data-sharing surface (Snowflake datashares, Snowflake
 * listings and Databricks deltashares).
 *
 * Mirrors the authorization catalog's checks on the `datashares` and
 * `databricks_deltashares` routes, so pages and write controls are hidden from a developer
 * the server would deny.
 *
 * @param hasPermission - the developer permission predicate, from `useDeveloperHasPermission`
 * @return `canViewDatashares` for the read routes, `canEditDatashares` for every write
 *   route (create, update and revoke alike)
 */
export const hasDatasharesPermissions = ({
  hasPermission,
}: {
  hasPermission: ReturnType<typeof useDeveloperHasPermission>;
}): { canViewDatashares: boolean; canEditDatashares: boolean } => {
  const hasViewCurrentsIntegrationsPermission = hasPermission("appGroup", {
    permission: "viewCurrentsIntegrations",
  });
  const hasEditCurrentsIntegrationsPermission = hasPermission("appGroup", {
    permission: "editCurrentsIntegrations",
  });

  return {
    canViewDatashares: hasViewCurrentsIntegrationsPermission || hasEditCurrentsIntegrationsPermission,
    canEditDatashares: hasEditCurrentsIntegrationsPermission,
  };
};
